<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
        <!-- Modal Header -->
        <div class="modal-header">
            <h6 class="modal-title">New Account</h6>
            <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <form @submit.prevent="createAccount">
                <div class="row">
                    <div class="col-12">
                        <label class="form-label">Location Name</label>
                        <input
                            type="text"
                            id="account_name"
                            class="col-12 col-sm-12 ma-input-field"
                            ref="account_name"
                            name="account_name"
                            v-model="company_name"
                            v-validate="'required'"
                            placeholder="Enter Location Name"
                            maxlength="250"
                            autocomplete="off">
                        <div v-if="verrors.firstByRule('account_name', 'required')" class="margin-bottom-5 validate-warning-msg">Location name is required</div>
                        <div v-if="verrors.firstByRule('account_name', 'exists')" class="margin-bottom-5 validate-warning-msg">Location name already exists</div>
                    </div>
                </div>
                 <div class="row">
                    <div class="col-12">
                        <label class="form-label">Address</label>
                        <div class="row">
                            <div class="col-12">
                                <input
                                    type="text"
                                    id="address"
                                    class="col-12 col-sm-12 ma-input-field"
                                    ref="address"
                                    name="address_one"
                                    v-model="address"
                                    placeholder="Address Line 1"
                                    maxlength="250"
                                    autocomplete="off">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <input
                                type="text"
                                id="address"
                                class="col-12 col-sm-12 ma-input-field"
                                ref="address"
                                name="address_two"
                                v-model="market_area"
                                placeholder="Address Line 2"
                                maxlength="250"
                                autocomplete="off">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 col-sm-4">
                                <input
                                    type="text"
                                    id="account_city"
                                    class="col-12 ma-input-field"
                                    ref="account_city"
                                    name="account_city"
                                    v-model="city"
                                    placeholder="City"
                                    maxlength="100"
                                    autocomplete="off">
                            </div>
                            <div class="col-4 col-sm-4 p-0">
                                <b-form-select
                                    name="account_state"
                                    id="account_state"
                                    class="col-12 ma-input-field"
                                    v-model="state_code"
                                    :options="state_options">
                                    </b-form-select>
                            </div>
                            <div class="col-4 col-sm-4">
                                <input
                                    type="text"
                                    name="account_zipcode"
                                    id="account_zipcode"
                                    class="col-12 ma-input-field"
                                    ref="zipcode"
                                    v-model="zip"
                                    placeholder="Zip Code"
                                    v-validate="{ rules: { regex: getPostalCodeRegex() } }"
                                    maxlength="10">
                                <div v-if="verrors.has('account_zipcode')" class="margin-bottom-5 validate-warning-msg">Postal code is invalid</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <label class="form-label">Primary Manager</label>
                        <div class="row">
                            <div class="col-6 col-sm-6">
                                <input
                                    type="text"
                                    id="admin_fname"
                                    class="col-12 ma-input-field"
                                    ref="admin_fname"
                                    name="admin_fname"
                                    v-model="admin_fname"
                                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                    placeholder="First Name"
                                    maxlength="250"
                                    autocomplete="off">
                                <div v-if="verrors.firstByRule('admin_fname', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
                                <div v-if="verrors.firstByRule('admin_fname', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
                            </div>
                            <div class="col-6 col-sm-6 pl-0">
                                <input
                                    type="text"
                                    id="admin_lname"
                                    class="col-12 ma-input-field"
                                    ref="admin_lname"
                                    name="admin_lname"
                                    v-model="admin_lname"
                                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                    placeholder="Last Name"
                                    maxlength="250"
                                    autocomplete="off">
                                <div v-if="verrors.firstByRule('admin_lname', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
                                <div v-if="verrors.firstByRule('admin_lname', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <input
                                    type="text"
                                    id="admin_email"
                                    class="col-12 col-sm-12 ma-input-field"
                                    ref="admin_email"
                                    name="admin_email"
                                    v-model="admin_email"
                                    v-validate="'required|email'"
                                    placeholder="Email"
                                    maxlength="250"
                                    autocomplete="off"
                                    @keyup.enter='enterSearchAction(index)'>
                                <div v-if="verrors.firstByRule('admin_email', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                                <div v-if="verrors.firstByRule('admin_email', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
                                <div v-if="verrors.firstByRule('admin_email', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <b-form-select
                                    class="col-12 ma-input-field"
                                    v-model="account_groups" 
                                    name="group"
                                    :options="account_groups_options"
                                    placeholder="Select Group for New Account">
                                    </b-form-select>
                                <div v-if="verrors.firstByRule('group', 'required')" class="margin-bottom-5 validate-warning-msg">Group is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center m-2">
                    <button type="submit" class="btn btn-sm btn-blue saveBtn text-center">Add Location</button>
                </div>
            </form>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import autoCompleteEnterprise from './autocomplete.vue';
import VeeValidate from 'vee-validate';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['enterpriseId', 'isModalVisible'],
  data() {
    return {
        loading: false,
        company_name: '',
        address: '',
        country_code: 'US',
        state_code: '',
        city: '',
        zip: '',
        market_area: '',
        admin_fname: '',
        admin_lname: '',
        admin_email: '',
        state_options: [
            { value: '', text: 'Select State' },
        ],
        status_options: [
            { value: '', text: 'Select Status' },
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' },
        ],
        account_groups_options: [],
        account_groups: '',
    }
  },
  components: {
    autoCompleteEnterprise,
  },
  methods: {
    closeModal() {
        this.company_name = '';
        this.address = '';
        this.market_area = '';
        this.city = '';
        this.state_code = '';
        this.zip = '';
        this.admin_fname = '';
        this.admin_lname = '';
        this.admin_email = '';
        this.verrors.clear();
        this.$emit('close');
    },
    nameRegex: function() {
        return /^[a-zA-Z-_ ']*$/;
    },
    getPostalCodeRegex() {
        return /^[0-9]{5}(?:-[0-9]{4})?$/;
    },
    getStateLists(CountryCode) {
        axios.get('/get-state-lists/' + CountryCode, {

        })
        .then(response =>  {
            this.state_options = response.data;
        })
        .catch(function(error) {

        });
    },
    createAccount() {
        this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
                axios('/enterprise_lookup_new_accounts/' + this.enterpriseId,
                {
                    method: 'POST',
                    data: {
                        "account": {
                            "company_name": this.company_name,
                            "master_admin": false,
                            "school_flag": 0,
                            "website": '',
                            "phone_no": '',
                            "phone_ext": '',
                            "fax": '',
                            "status": '',
                            "naics_code": '',
                            "naics_id": '',
                            "naics_description": '',
                            "naics_label": '',
                            "researcher_notes": '',
                            "location": {
                                "address": this.address,
                                "country_code": 'US',
                                "state_code": this.state_code,
                                "city": this.city,
                                "zip": this.zip,
                                "market_area": this.market_area,
                            },
                            "program": 'Mentorship',
                        },
                        "userInfo": {
                            "uid": 0,
                            "admin_fname": this.admin_fname,
                            "admin_lname": this.admin_lname,
                            "admin_email": this.admin_email,
                            "admin_title": '',
                            "is_enabled": 0,
                            "is_manager": 1,
                            "is_news": 0,
                            "is_billingadmin": 0,
                            "is_primaryadmin": 1,
                            "admin_status": 'Active',
                            "id_number": '',
                            "password": '',
                            "mobile": '',
                            "phone": '',
                            "phone_ext": '',
                            "location_name": '',
                            "country": '',
                            "address": '',
                            "city": '',
                            "zip": '',
                            "state": '',
                            "market_area": '',
                            "remove_flag": false,
                            "last_login": '',
                            "no_login": '',
                            "is_mentee": 0,
                            "admin_courses": [],
                        },
                        "account_groups": {
                            "group": this.account_groups
                        }
                    }
                })
                .then(response => {
                    this.closeModal();
                    this.$parent.getAccountsListData();
                })
                .catch(error => {
                    const fieldErrors =  [];
                    const fieldErrors1 =  [];
                    var error_msg = error.response.data.message;
                    var data_array = error_msg.split(',');
                    for(var i=0; i<data_array.length; i++) {
                      var data_array_value = data_array[i];
                      
                      data_array_value = data_array_value.replace("{", "");
                      data_array_value = data_array_value.replace("}", "");
                      data_array_value = "{"+data_array_value+"}";
                      var errMsgObj = JSON.parse(data_array_value);
                      
                      Object.keys(errMsgObj).map(key => {
                        if(key == 'account_name') {
                            var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                            fieldErrors1.push(newFieldErr);
                        }
                        else {
                            var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                            fieldErrors1.push(newFieldErr);
                        }
                      });
                    }
                    this.$validator.errors.add(fieldErrors1);
                })
            }
        })
        .catch(() => {
        });
    },
    getEnterpriseGroups() {
        if (this.enterpriseId > 0) {
            axios('/enterprise-admin/groups/' + this.enterpriseId,
            {
                method: 'GET',
            })
            .then(response => {
                var groupsCount = response.data.groups.length;
                this.account_groups_options.push({ text:'Select Group for New Account', value: '' });
                for (var m = 0; m < groupsCount; m++) {
                    this.account_groups_options.push({ 
                        text: response.data.groups[m].text, 
                        value: response.data.groups[m].value 
                    });
                }
            })
            .catch(() => {
            });
        }
    },
  },
  created() {
      this.verrors.clear();
      this.getStateLists('US');
      this.getEnterpriseGroups();
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
  margin: 0px 10px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 15px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.mx-datepicker { width: 100%; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
@media (min-width: 1280px) { 
  .form-group {
    margin: 20px;
  }
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 38px;
}
.form-label {
    color: #7d7d7d;
    font-size: 13px;
    font-weight: 900;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/new_account_modal.vue